// utils/userUtils.ts

/**
 * Extract up to `maxLength` initials from a person's name.
 *
 * Examples:
 *   getInitials("John Doe")       -> "JD"
 *   getInitials("Alice")          -> "A"
 *   getInitials("A B C", 3)       -> "ABC"
 */
export function getInitials(name: string, maxLength = 2): string {
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .slice(0, maxLength);
}
